
import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import acnt from 'accounting';
import { head, sortBy } from 'lodash';

import { EventDateInfo } from '../../../mvcapi/models/common';
import { EventInfoModelShape } from '../../organisms/buytickets/types';
import { EventDateSelection, WhereToBuy } from '../../organisms/buytickets';

import TranslateManager from 'ts-translate-js';
import { CreateReactClassComponent } from '../../../types/createreactapp';
import { checkHasSameVenueNames, getEventDateDisplayMode } from '../../../logic/sales-util';
const tr = TranslateManager.boundTR;


const getPrefixedVenueName = (venueName) => {
    let pref = "";

    // Mappings (In a function so the translation is dynamic and not only on load of the file)
    if(venueName === "Théâtre Marcellin-Champagnat") pref = tr("Au");
    else if(venueName === "Salle André-Mathieu") pref = tr("A la");

    return pref + " " + venueName;
};


interface ProgramInfoProps {
    programID: string;
    eventID: number;
    eventDateInfos: EventDateInfo[];
    selectedEventDate: EventDateInfo;
    prices: any[];
    onContentChange: () => void;
    onChangeEventDate: (eventDateInfo: EventDateInfo, triggerBuy?: boolean) => void;
    onBuyClick: () => void;
    loadingProductInfo: boolean;
    onMembershipPresaleClick: (membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) => void;
    returnToPackageUrl: string;
    onPromoUpdated: () => void;
    hiddenPromo: boolean;
    integ: string;
    overview?: boolean;
    
}

interface ProgramInfoState {}

type ProgramInfoInterface = CreateReactClassComponent<typeof ProgramInfoDef, ProgramInfoProps, ProgramInfoState>;

// type eventDateDisplayMode = "combo" | "button";

export const ProgramInfoDef = {
    displayName: "ProgramInfo",

    propTypes: {
        programID: PropTypes.string, // It it's a program
        eventID: PropTypes.number, // If not a real program
        eventDateInfos: PropTypes.arrayOf(EventInfoModelShape),
        selectedEventDate: EventInfoModelShape,
        prices: PropTypes.arrayOf(
            PropTypes.shape({
                orderIndex: PropTypes.number,
                nameFr: PropTypes.string,
                price: PropTypes.number,
                fees: PropTypes.number
        })),
        onContentChange: PropTypes.func,
        onChangeEventDate: PropTypes.func,
        onBuyClick: PropTypes.func,
        onMembershipPresaleClick: PropTypes.func,
        returnToPackageUrl: PropTypes.string,
        loadingProductInfo: PropTypes.bool,
        onPromoUpdated: PropTypes.func,
        hiddenPromo: PropTypes.bool
    },

    componentDidMount: function() {
        const _this: ProgramInfoInterface = this;
        _this.raiseContentChanged();
    },

    componentDidUpdate: function () {
        const _this: ProgramInfoInterface = this;
        _this.raiseContentChanged();
    },

    raiseContentChanged() {
        const _this: ProgramInfoInterface = this;
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(_this.props.onContentChange !== undefined) _this.props.onContentChange();
        }.bind(_this), 0);
    },

    handleOnChangeEventDate(eventDateInfo, triggerBuy = false) {
        const _this: ProgramInfoInterface = this;
        if(_this.props.onChangeEventDate != undefined)
            _this.props.onChangeEventDate(eventDateInfo, triggerBuy);
    },

    handleOnBuyClick: function() {
        const _this: ProgramInfoInterface = this;
        if(_this.props.onBuyClick !== undefined) _this.props.onBuyClick();
    },

    render() {
        const _this: ProgramInfoInterface = this;
        let content = null;
        let datesAvailable = false;  // We use _this when no date in the program for the "0_NONE" program


        const isDisplayModeCombo = getEventDateDisplayMode(this.props.eventDateInfos) == "combo";

        if(_this.props.eventDateInfos != null) {
            if(_this.props.eventDateInfos.length > 0) {
                datesAvailable = true;
                content = (
                    <EventDateSelection
                        eventDateInfos={_this.props.eventDateInfos}
                        selectedEventDate={isDisplayModeCombo ? _this.props.selectedEventDate : null}
                        onContentChange={_this.props.onContentChange}
                        onBuyClick={_this.handleOnBuyClick}
                        onChangeEventDate={_this.handleOnChangeEventDate}
                        loadingProductInfo={_this.props.loadingProductInfo}
                        returnToPackageUrl={_this.props.returnToPackageUrl}
                        onPromoUpdated={_this.props.onPromoUpdated}
                        hiddenPromo={_this.props.hiddenPromo}
                        onMembershipPresaleClick={_this.props.onMembershipPresaleClick}
                        integ={_this.props.integ}
                    />
                );
            } else {
                content = (
                    <div className="row">
                        <div className="col-xs-12 text-center">
                            <h4>{tr("Aucune représentation disponible pour le moment...")}</h4>
                        </div>
                    </div>
                );
            }

        } else {
            content = <h4><strong>{tr("Chargement de la programmation en cours...")}</strong></h4>;
        }

        let pricesCtl;
        if(_this.props.prices && _this.props.prices.length > 0 && datesAvailable){
            const orderedPrices = sortBy(_this.props.prices, ["orderIndex"]);
            const firstPrice = head(orderedPrices);

            pricesCtl = (
                <div className="text-center">
                    <h4>
                        <small>{tr("program.pricelist.startingfrom")}</small>
                        <ul className="list-inline price-list">
                            {orderedPrices.map((p) =>
                                <li key={p.nameFr}>
                                    <span>{p.nameFr}</span><span>{tr("general.colon")}</span><span className="price-amount">{acnt.formatMoney(p.price)}</span>
                                </li>
                            )}
                        </ul>

                    </h4>
                    <small>{tr("* Le prix inclut les taxes et les frais de service de {fees} par billet. Quantités limitées.", { fees: acnt.formatMoney(firstPrice.fees) })}</small>
                </div>
            );
        }

        let venueName;
        if(_this.props.selectedEventDate != null && datesAvailable && checkHasSameVenueNames(_this.props.eventDateInfos)) {
            venueName = (
                <div className="row">
                    <p className="col-xs-12 text-center venuename accented-text">
                        {getPrefixedVenueName(_this.props.selectedEventDate.VenueName)}
                    </p>
                </div>
            );
        }

        let contactSection;
        if(!_this.props.overview && datesAvailable) { // We hide when no date in the program form the "0_NONE" program
            const whereToBuyUrl =
                _this.props.eventID != undefined ? "/events/" + _this.props.eventID + "/wheretobuy"
                : "/programs/" + _this.props.programID + "/wheretobuy";
            
            contactSection = (
                <div className="row">
                    <div className="col-xs-12 text-center">
                        <WhereToBuy whereToBuyRestUrl={whereToBuyUrl} integ={_this.props.integ} onContentChange={_this.props.onContentChange} />
                    </div>
                </div>
            );
        }

        return (
            <div className="program-info-widget">
                {content}
                {venueName}
                {pricesCtl}
                {contactSection}
            </div>
        );
    }

};

export const ProgramInfo = createClass<ProgramInfoProps>(ProgramInfoDef);